
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/onetrust",
      function () {
        return require("private-next-pages/customer-studio/onetrust.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/onetrust"])
      });
    }
  